(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loading"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  // グローバルエラーハンドラー
  window.addEventListener('error', function(e) {
    console.error('Loading screen error:', e);
  });
  
  var loader = document.getElementById('loading');
  if (!loader) {
    console.warn('Loading element not found');
    return;
  }
  
  // 背景色設定
  try {
    var bg = loader.getAttribute('data-bg') || '#ffffff';
    loader.style.backgroundColor = bg;
  } catch(e) {
    console.error('BG color error:', e);
  }
  
  // bodyスクロール防止
  document.body.classList.add('no-scroll');
  
  var hideTimer;
  var forceTimer;
  var isHidden = false;
  
  // === 確実に消す関数 ===
  function hideLoading() {
    if (isHidden) return;
    isHidden = true;
    
    console.log('Hiding loading screen');
    
    clearTimeout(hideTimer);
    clearTimeout(forceTimer);
    
    try {
      loader.classList.add('hide');
      document.body.classList.remove('no-scroll');
      
      setTimeout(function() {
        try {
          loader.style.display = 'none';
          
          // visited フラグ保存
          try {
            sessionStorage.setItem('shopify_visited', 'true');
            localStorage.setItem('shopify_visited', 'true');
          } catch(e) {}
          
        } catch(e) {
          console.error('Hide error:', e);
        }
      }, 600);
      
    } catch(e) {
      console.error('Hide animation error:', e);
      // フォールバック
      loader.style.display = 'none';
      document.body.classList.remove('no-scroll');
    }
  }
  
  // === 多重フェイルセーフ ===
  
  // 1. 即座にタイマー開始（2秒で強制終了）
  forceTimer = setTimeout(function() {
    console.warn('FORCE HIDE - timeout reached');
    hideLoading();
  }, 2000);
  
  // 2. DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('DOMContentLoaded triggered');
      hideTimer = setTimeout(hideLoading, 500);
    });
  } else {
    console.log('DOM already loaded');
    hideTimer = setTimeout(hideLoading, 500);
  }
  
  // 3. window.load
  window.addEventListener('load', function() {
    console.log('window.load triggered');
    if (!isHidden) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideLoading, 500);
    }
  });
  
  // 4. 緊急脱出：クリック/タップ
  var tapCount = 0;
  function emergencyExit(e) {
    tapCount++;
    console.log('Tap count:', tapCount);
    
    if (tapCount >= 1) {
      console.warn('EMERGENCY EXIT - user interaction');
      e.preventDefault();
      e.stopPropagation();
      hideLoading();
    }
  }
  
  try {
    loader.addEventListener('click', emergencyExit);
    loader.addEventListener('touchstart', emergencyExit, {passive: false});
  } catch(e) {
    console.error('Event listener error:', e);
  }
  
  // 5. bfcache対策
  window.addEventListener('pageshow', function(event) {
    console.log('pageshow event, persisted:', event.persisted);
    if (event.persisted) {
      hideLoading();
    }
  });
  
  // 6. visibilitychange
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && !isHidden) {
      console.log('Page became visible');
      setTimeout(hideLoading, 100);
    }
  });
  
  console.log('Loading screen initialized');
  
})();

  } catch(e) { console.error(e); }
})();
})();
